import { Badge, Flex, Grid, Loader } from "@aws-amplify/ui-react";
import { CCard } from "@coreui/react";
import { API, graphqlOperation } from "aws-amplify";
import { serviceOrderEquipmentsByServiceOrderId } from "graphql/queries";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import LocalizedStrings from "react-localization";

const EquipmentsList = ({ serviceOrderID }) => {
  const [equipments, setEquipments] = useState([]);
  const [loading, setLoading] = useState(false);

  async function fetchEquipments(id) {
    try {
      setLoading(true);
      const equipmentsData = (
        await API.graphql(
          graphqlOperation(serviceOrderEquipmentsByServiceOrderId, {
            serviceOrderId: id,
            limit: 500,
          })
        )
      ).data.serviceOrderEquipmentsByServiceOrderId.items;

      setEquipments(
        equipmentsData?.map((it) => ({
          id: it.equipment.id,
          name: it.equipment.name,
        })) ?? []
      );
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchEquipments(serviceOrderID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceOrderID]);

  return (
    <CCard
      className="p-3"
      borderRadius="medium"
      variation="outlined"
      style={{ height: "100%" }}
    >
      <Grid gap="5px">
        <span className="fs-5">{strings.equipments}</span>
        {loading ? (
          <Loader />
        ) : equipments.length > 0 ? (
          <Flex rowGap="10px" columnGap="10px" wrap="wrap">
            {equipments.map((equipment, index) => (
              <Badge className="avoidBreak" key={index}>{equipment.name}</Badge>
            ))}
          </Flex>
        ) : (
          strings.noEquipments
        )}
      </Grid>
    </CCard>
  );
};

const strings = new LocalizedStrings({
  es: {
    equipments: "Equipos asociados",
    noEquipments: "Sin equipos asociados...",
    responses: {
      errorFetch: "Error al obtener los equipos asociados.",
    },
  },
});

export default EquipmentsList;
